var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2502 2C20.3201 2 22 3.68 22 5.75V18.25C22 20.32 20.3201 22 18.2502 22H15.8019V14.2525H18.3927L18.7835 11.2317H15.8019V9.305C15.8019 8.4325 16.0361 7.84667 17.2994 7.84667L18.8876 7.83333V5.13833C18.6143 5.09917 17.6635 5.02083 16.5702 5.02083C14.2653 5.02083 12.6771 6.42667 12.6771 9.005V11.2317H10.073V14.2525H12.6771V22H5.74984C4.75546 21.9996 3.80193 21.6043 3.09879 20.9012C2.39566 20.198 2.00044 19.2444 2 18.25V5.75C2 3.68 3.67993 2 5.74984 2H18.2493H18.2502Z",
    fill: "#0866FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceFacebook);
export default __webpack_public_path__ + "static/media/source-facebook.95199864effbdf058ea61c027fb45d61.svg";
export { ForwardRef as ReactComponent };